import React, { useEffect, useState } from 'react';
import SideDrawer from '../components/SideDrawer';
import SideDrawerMobileView from '../components/SideDrawerMobileView';
import Header from '../components/Header';
import { useAuth } from '../contexts/AuthContext';
import useIsMobile from '../hooks/useIsMobile';

const MainLayout = ({ children }) => {
  const { isCollapsed } = useAuth();
  const isMobile = useIsMobile();
  const [isTablet, setIsTablet] = useState(false);
const [isSmallDesktop, setIsSmallDesktop] = useState(false);

useEffect(() => {
  const handleResize = () => {
    const width = window.innerWidth;

    setIsTablet(width > 768 && width <= 1024);
    setIsSmallDesktop(width > 1024 && width <= 1370);
  };

  handleResize(); // run once on load
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);

  // Set widths based on device + collapsed state
  let drawerWidth = '15%';
  let contentWidth = '85%';

  if (isTablet) {
    drawerWidth = '25%';
    contentWidth = '75%';
  }

  if (isSmallDesktop && !isMobile) {
    drawerWidth = '18%';
    contentWidth = '82%';
  } 

  if (isCollapsed && !isMobile) {
    drawerWidth = '5%';
    contentWidth = '95%';
  }

  if (isMobile) {
    drawerWidth = '100%';
    contentWidth = '100%';
  }

  return (
    <div
      className={`App d-flex ${isMobile ? 'flex-column' : ''}`}
      style={{ width: '100%' }}
    >
      {/* Sidebar or Topbar */}
      {isMobile ? (
        <div style={{ width: '100%' }}>
          <SideDrawerMobileView />
          <Header />
        </div>
      ) : (
        <div style={{ width: drawerWidth }}>
          <SideDrawer />
        </div>
      )}

      {/* Main Content */}
      <div
        className="main-container d-flex flex-column"
        style={{ width: isMobile ? '100%' : contentWidth }}
      >
        {!isMobile && <Header />}
        <div className="content px-3 py-2">
          {React.cloneElement(children, { isMobile })}
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
